import * as React from "react";
import { Prestation, PrestationStatus } from "src/redux/projects";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { config } from "src/config/config";
import "react-fancybox/lib/fancybox.css";
import { HeaderPage } from "./HeaderPage";

interface Props {
  prestations: Prestation[];
  projectId: number;
  projectName: string;
}
type PropsWithNameSpaces = Props & WithNamespaces;
const DownloadableMedias = (props: PropsWithNameSpaces) => {
  const prestationsDelivery = props.prestations.filter(
    p => p.status === PrestationStatus.Delivery
  );
  let link = `${config.downloadUrl}drive?`;
  prestationsDelivery.map(
    (p, index) => (link += `illustr%5B${index}%5D=${p.deliveryId}&`)
  );
  link += `id=${props.projectId}&type=5`;
  return (
    <div className="medias p-5">
      <div className="mb-4">
        <HeaderPage title={props.projectName} back={true} />
      </div>
      <div className="p-0 container-fluid">
        <div className="align-items-center d-flex mb-3">
          <h2 className="flex-1">{props.t("library.medias.title")}</h2>
          <a
            href={link}
            className="btn btn-secondary d-flex align-items-center border-0"
          >
            <img width="20px" src="assets/svgs/download.svg" />
            <p className="font-weight-normal mb-0 ml-2">
              {props.t("library.medias.downloadAll")}
            </p>
          </a>
        </div>
        <div className="row">
          {prestationsDelivery.map(p => (
            <div key={p.id} className="col-12 col-lg-2 col-md-4 col-sm-6 mb-4">
              <div className="card card-media">
                <div className="card-header">
                  <div className="card-header-img">
                    {p.image ? (
                      <div>
                        <a data-fancybox="gallery" href={p.imageDelivery}>
                          <img src={p.image} />
                        </a>
                      </div>
                    ) : (
                      <img className="default" src="assets/presta-defaut.jpg" />
                    )}
                  </div>
                  <div className="card-header-footer">
                    <div>
                      <h5>{p.name}</h5>
                    </div>
                    <div className="h-100 d-flex">
                      <a href={p.delivery}>
                        <img src="assets/svgs/download.svg" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default withNamespaces()(DownloadableMedias);



// WEBPACK FOOTER //
// ./src/components/DownloadableMedias.tsx